import React from 'react'
import { Button, Modal } from 'antd'
import { FormattedMessage } from 'react-intl'

import Confetti from './Confetti'
import styles from './financeOnboarding.module.scss'

const ITEMS = [1, 2, 3]

const FinishModal = ({ open, name, onClose }) => (
  <>
    {open && <Confetti />}
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      width="min(560px, calc(100vw - 32px))"
      zIndex={10050}
      className={styles.finishModal}
    >
      <div className={styles.finish}>
        <svg width="90" height="90" viewBox="0 0 90 90" aria-hidden="true">
          <circle cx="45" cy="45" r="42" fill="#e6f7ef" />
          <circle cx="45" cy="45" r="30" fill="#46be8a" />
          <path
            d="M31 46 l9 9 19-21"
            fill="none"
            stroke="#fff"
            strokeWidth="6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <h2>
          <FormattedMessage id="financeOnboarding.finish_title" values={{ name }} />
        </h2>
        <p>
          <FormattedMessage id="financeOnboarding.finish_desc" />
        </p>
        <div className={styles.doneList}>
          {ITEMS.map((n) => (
            <div key={n}>
              <i>✓</i>
              <FormattedMessage id={`financeOnboarding.finish_item${n}`} />
            </div>
          ))}
        </div>
        <Button type="primary" size="large" onClick={onClose} id="btn-finance-onboarding-close">
          <FormattedMessage id="financeOnboarding.finish_button" />
        </Button>
        <p className={styles.fine}>
          <FormattedMessage id="financeOnboarding.finish_note" />
        </p>
      </div>
    </Modal>
  </>
)

export default FinishModal
